import * as tslib_1 from "tslib";
import { DateTime } from 'luxon';
import { pickBy, isArray } from 'lodash';
import { Model } from '@app/models/model';
import { config } from '@config/config';
var Query = /** @class */ (function (_super) {
    tslib_1.__extends(Query, _super);
    function Query(input) {
        var _this = _super.call(this, {}) || this;
        if (input) {
            _this.device_id = input.device_id;
            _this.since_datetime =
                typeof input.since_datetime === 'string'
                    ? input.since_datetime
                    : input.since_datetime.toFormat(config.datetimeFormats.QUERY);
            _this.until_datetime =
                typeof input.until_datetime === 'string'
                    ? input.until_datetime
                    : input.until_datetime.toFormat(config.datetimeFormats.QUERY);
            _this.bucket = input.bucket;
            _this.group_multiplier = input.group_multiplier || 1;
            _this.operation = input.operation;
            _this.units = input.units;
            _this.data = input.data;
            _this.value = input.value;
            _this.types = input.types;
            _this.previous_period = input.previous_period;
            // Fix for really long usage alerts with too many data points
            if (_this.bucket === 'MIN' &&
                DateTime.fromSQL(_this.until_datetime).diff(DateTime.fromSQL(_this.since_datetime), 'hours').hours > 16) {
                _this.until_datetime = DateTime.fromSQL(_this.since_datetime)
                    .plus({ hours: 16 })
                    .toFormat(config.datetimeFormats.QUERY);
            }
            _this.updateID();
        }
        return _this;
    }
    Query.prototype.updateID = function () {
        var arr = [
            this.since_datetime ? this.since_datetime : '',
            this.until_datetime ? this.until_datetime : '',
            this.bucket,
            this.group_multiplier,
            this.operation,
            this.units,
            this.types,
            this.previous_period,
        ].filter(function (val) { return !!val; });
        this.queryId = arr.join('|');
        arr.unshift(this.device_id);
        this.id = arr.join('|');
    };
    Query.prototype.setData = function (input) {
        if (isArray(input) && !input[0].datetime) {
            this.value = input[0].value;
        }
        else if (isArray(input)) {
            this.data = input;
        }
        else {
            this.value = input.value;
        }
    };
    Query.prototype.toRequestBody = function () {
        return pickBy({
            request_id: this.id,
            since_datetime: this.since_datetime,
            until_datetime: this.until_datetime,
            bucket: this.bucket,
            group_multiplier: this.group_multiplier,
            operation: this.operation,
            units: this.units,
            types: this.types,
            previous_period: this.previous_period,
        }, function (val) { return !!val; });
    };
    return Query;
}(Model));
export { Query };
